import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-billing-branch',
  templateUrl: './payment-billing-branch.component.html',
  styleUrls: ['./payment-billing-branch.component.scss']
})
export class PaymentBillingBranchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
